<template>
  <div>
    <slot></slot>
    <h3 class="twoline">{{desc}}</h3>
    <div class="card">
      <router-link  :to="`/goods/detail/${album.id}`">
        <div class="desc">
          <div>
            <h4 class="twoline">{{album.name}}</h4>
            <p class="twoline">{{album.description}}</p>
          </div>
          <div class="navigate">
          </div>
        </div>
      </router-link>
      <div class="position">
        <img :src="album.displayBigPhoto" alt="">
        <div v-if="audition" class="time">{{audition.length|durationChineseFormat}}</div>
        <div @click="$emit('togglePlay',true,index)" v-show="!active" class="btn play"></div>
        <div @click="$emit('togglePlay',false,index)" v-show="active" class="btn pause"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { durationChineseFormat } from "@/utils/filter";
export default {
  props: ["active", "index", "album", "audition","desc"],
  filters: { durationChineseFormat }
};
</script>

<style scoped>
.twoline {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
h3 {
  font-size: 16px;
  line-height: 22px;
  color: #244352;
  background-position: 18px 21px;
  padding: 20px 35px 0 20px;
  font-weight: bold;
  margin-bottom: 14px;
}
.desc {
  padding: 0 0 8px 14px;
  display: flex;
}
.desc h4 {
  font-size: 16px;
  padding-top: 14px;
  color: #244352;
  line-height: 22px;
  margin-bottom: 4px;
}
.desc p {
  font-size: 12px;
  color: rgba(106, 146, 164, 1);
  line-height: 17px;
}
.desc > div {
  flex: 1 1 auto;
}
.desc .navigate {
  width: 44px;
  height: 44px;
  flex: 0 0 auto;
  background: url("/images/vip/fans3.png") no-repeat center;
}

.card {
  margin: 0 20px;
  box-shadow: 0px 6px 9px 0px rgba(0, 71, 108, 0.16);
  border-radius: 12px;
  overflow: hidden;
}
.position {
  position: relative;
}
.card img {
  display: block;
  width: 100%;
  height: 335px;
}
.time {
  position: absolute;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  padding-right: 6px;
  text-align: right;
  width: 100%;
  box-sizing: border-box;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  line-height: 29px;
}
.btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.play {
  background: url("/images/vip/fans_play.png") center no-repeat;
}
.pause {
  background: url("/images/vip/fans_pause.png") center no-repeat;
}
</style>